import { saveAs } from 'file-saver';

const textDownload = (text, fname) => saveAs(new Blob([text], { type: 'octet/stream' }), fname);

const jsonDownload = (json, fname) => {
  textDownload(JSON.stringify(json, null, 2), fname);
};

const startDownload = (url) => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'display:none');
  iframe.src = url;
  document.body.appendChild(iframe);

  setTimeout(() => {
    if (iframe.parentNode) {
      document.body.removeChild(iframe);
    }
  }, 5000);
};

export default {
  jsonDownload,
  startDownload,
  textDownload,
};
